'use strict';

var TDChartSeasonsAggregationFactory = function TDChartSeasonsAggregationFactory(DataAggregationFactory, ExtractMetricKeysService, SeasonLabelFormattingService) {
  function TDChartSeasonsAggregation() {
    DataAggregationFactory.call(this, ['market-product-group', 'market'], 'thematic-demand-chart-market-seasons');
  }
  TDChartSeasonsAggregation.prototype = Object.create(DataAggregationFactory.prototype);
  TDChartSeasonsAggregation.prototype.canAggregate = function (sourceType, targetType) {
    return this.sourceType.indexOf(sourceType) !== -1 && targetType === this.targetType;
  };
  TDChartSeasonsAggregation.constructor = TDChartSeasonsAggregation;
  TDChartSeasonsAggregation.prototype.aggregate = function (data, metrics) {
    var aggregationFunction = this.getAggregationFunction(metrics);
    var aggregatedSeasons = {};
    var reducedEntry, metricKeys, keysLength, keys;
    for (var index = 0, dataLength = data.length; index < dataLength; index++) {
      var effectiveSeason = data[index].seasonOverride || data[index].season;
      if (Array.isArray(aggregatedSeasons[effectiveSeason])) {
        aggregatedSeasons[effectiveSeason].push(data[index]);
      } else {
        aggregatedSeasons[effectiveSeason] = [data[index]];
      }
    }
    if (Object.keys(aggregatedSeasons).length > 0) {
      metricKeys = ExtractMetricKeysService.extract(aggregatedSeasons[Object.keys(aggregatedSeasons)[0]][0]);
    }
    keys = Object.keys(aggregatedSeasons);
    for (index = 0, keysLength = keys.length; index < keysLength; index++) {
      reducedEntry = {};
      reducedEntry.label = keys[index];
      aggregationFunction(aggregatedSeasons[keys[index]], metricKeys, reducedEntry);
      aggregatedSeasons[keys[index]] = reducedEntry;
    }
    return SeasonLabelFormattingService.formatSeasonLabels(this.sortAggregationResults(aggregatedSeasons));
  };
  return TDChartSeasonsAggregation;
};
TDChartSeasonsAggregationFactory.$inject = ['DataAggregationFactory', 'ExtractMetricKeysService', 'SeasonLabelFormattingService'];
module.exports = TDChartSeasonsAggregationFactory;